import axiosInstance from './axios';
export const axiosI = axiosInstance;

export { useTranslation as useI18 } from 'i18next-vue';
export * from './sanitize-script';
